<ng-container [ngSwitch]="datePickerType">
  <ui2-datepicker-range
    *ngSwitchCase="ui2DatePickerType.RangePicker"
    [clearable]="clearable"
    [class.disabled]="disabled"
    [class.required]="required"
    [class.readonly]="readonly"
    [class.styled]="styled"
    [placeholder]="placeholder"
    [datePickerModel]="localValue"
    (dateChanged)="selectionChange($event)"
    [customClass]="customClass"
    (focusChange)="focusChange.emit($event)"
  ></ui2-datepicker-range>
  <ui2-datepicker-single
    *ngSwitchCase="ui2DatePickerType.SinglePicker"
    [clearable]="clearable"
    [class.disabled]="disabled"
    [class.required]="required"
    [class.readonly]="readonly"
    [class.styled]="styled"
    [placeholder]="placeholder"
    [datePickerModel]="localValue"
    (dateChanged)="selectionChange($event)"
    (focusChange)="focusChange.emit($event)"
  ></ui2-datepicker-single>
  <ui2-datepicker-quick-options
    #quickOptionPanel
    *ngSwitchCase="ui2DatePickerType.QuickOptionsPicker"
    [clearable]="clearable"
    [class.disabled]="disabled"
    [class.required]="required"
    [class.readonly]="readonly"
    [class.styled]="styled"
    [placeholder]="placeholder"
    [datePickerModel]="localValue"
    [customClass]="customClass"
    [options]="quickOptions"
    (dateChanged)="selectionChange($event)"
    (focusChange)="focusChange.emit($event)"
  ></ui2-datepicker-quick-options>
</ng-container>
